// extracted by mini-css-extract-plugin
export var actionButton = "_jb-t";
export var buttonContainer = "_jb-0";
export var buttonContainer2 = "_jb-1";
export var buttonSection = "_jb-2";
export var details = "_jb-3";
export var dropdownItem = "_jb-5";
export var dropdownItemsContainer = "_jb-4";
export var fileInput = "_jb-r";
export var headerButton = "_jb-6";
export var icon = "_jb-7";
export var input = "_jb-8";
export var macroListItem = "_jb-9";
export var mainContent = "_jb-a";
export var microText = "_jb-b";
export var modal = "_jb-w";
export var optionsButton = "_jb-c";
export var paperclip = "_jb-s";
export var pillContent = "_jb-d";
export var preview = "_jb-e";
export var preview2 = "_jb-f";
export var quillEditor = "_jb-q";
export var selectedMacro = "_jb-g";
export var sidebar = "_jb-h";
export var sidebarHeader = "_jb-j";
export var sidebarList = "_jb-i";
export var sidebarListItem = "_jb-k";
export var sidebarSearch = "_jb-l";
export var snoozeDurationWrapper = "_jb-v";
export var statusPillContainer = "_jb-m";
export var tagsContainer = "_jb-n";
export var unselectedMacro = "_jb-o";
export var variable = "_jb-u";
export var wrapper = "_jb-p";